<template>
  <div class="home main-container">
    <div class="header__helper-container">
      <SearchBox placeholder="Search for a country ..."/>
      <Select :options="selectOption"
      @filterCountries="filterCountries"
      />
    </div>
    <div class="cards-container" v-if="filteredCountries.length">
      <Card 
      v-for="country in filteredCountries" :key="country.callingCodes"
      :country="country" 
      />
    </div>
    <div class="loading" v-else>Loading Content</div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
// @ is an alias to /src
import SearchBox from '../components/TheSearchBox'
import Select from '../components/TheSelectMenu'
// import Card from '../components/AppCards.vue'
const Card = defineAsyncComponent(() => import('../components/AppCards.vue' /* webpackChunkName: card */))
export default {
  name: 'Home',
  data() {
    return {
      isCountryFlagLoading: true,
      showCountriesIn: 'Asia',
      selectOption: [
        {id: 1, value: 'Africa'},
        {id: 2, value: 'Americas'},
        {id: 3, value: 'Asia'},
        {id: 4, value: 'Europe'},
        {id: 5, value: 'Oceania'}
        ],
      allCountries: [],
      filteredCountries: []
    }
  },
  components: { SearchBox, Select, Card },
  watch: {
    //Filter Countries by Region
    showCountriesIn(curRegion) {
      this.filteredCountries = this.allCountries.filter(country => {
        return country.region === curRegion
      })
    }
  },
  methods: {
    filterCountries(selectedRegion) {
      this.showCountriesIn = selectedRegion
    }
  },
  mounted() {
    fetch('https://restcountries.eu/rest/v2/all')
      .then(res => res.json())
      .then(data => {
          this.allCountries = data
          this.filteredCountries = data.filter(country => {
            return country.region === 'Asia'
          })
          this.isCountryFlagLoading = false
        })
      .catch(err => console.log('something went wrong' + err))
  }
}
</script>

<style lang="scss">
.main-container {
  width: 90%;
  max-width: 82.5rem;
  margin: 0 auto;
}


.header__helper-container {
  @media (min-width: 46.88em) {
    display: flex;
    justify-content: space-between;
  }
}

.cards-container {
  display: flex;
  flex-flow: row wrap;
  gap: 1.875rem;
}

</style>